import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { invoke } from 'q';
import { Common } from '../../lib/common'

export interface MessagePopoverButton {
  name: string,
  type: string,
  action?: (popover: MessagePopoverComponent) => any,
  clickAction?: (popover: MessagePopoverComponent) => any, // This gets called immediately on the click. It is needed so we can call window.open which must be called from a click handler rather than from an async routine
  info?: any     // passed by caller to be used as caller sees fit
}

@Component({
  selector: 'app-message-popover',
  templateUrl: './message-popover.component.html',
  styleUrls: ['./message-popover.component.scss']
})
export class MessagePopoverComponent implements OnInit {

  popoverCtrl: PopoverController
  title: string = ''
  message: string = ''
  hasClose: boolean = false
  buttonsVertical: boolean = false
  buttons: MessagePopoverButton[] = []
  selectedButton: MessagePopoverButton = null
  selectedIndex = -1

  constructor() { }

  static present(popoverCtrl: PopoverController,
                 title: string,
                 message: string = '',
                 hasClose: boolean = true,
                 buttonsVertical: boolean = true,
                 buttons: MessagePopoverButton[] = [],
                 onDismiss?: (popover: MessagePopoverComponent) => any) {
    popoverCtrl.create({component: MessagePopoverComponent}).then(popover => {
      if (buttons.length === 0) {
        buttonsVertical = true
        buttons = [
          { name: 'OK', type: MessagePopoverButton.Type.Cancel }
        ]
      }

      popover.cssClass = 'message-popover'
      popover.componentProps = { popoverCtrl: popoverCtrl, title: title, message: message, hasClose: hasClose, buttonsVertical: buttonsVertical, buttons: buttons }
      popover.present().then(() => Common.ensurePopoverOnScreen())

      popover.onDidDismiss().then( results => {
        if (results.data && results.data.selectedButton.action) {
          results.data.selectedButton.action(this)
        }
        if (onDismiss) {
          onDismiss.call(this)
        }
      })
    })
  }

  ngOnInit() {
  }

  select(button: MessagePopoverButton) {
    if (button.clickAction) {
      button.clickAction(this)
    }

    this.selectedButton = button
    this.selectedIndex = this.buttons.indexOf(button)
    this.popoverCtrl.dismiss(this)
  }

  dismiss() {
    this.popoverCtrl.dismiss()
  }
}

export namespace MessagePopoverButton {
  export enum Type {
      Cancel = 'cancel',
      Submit = 'submit',
  }
}
